<template>
  <div class="vx-card">
    <div class="vx-card__header text-center p-3">
      <div class="vx-card__title w-full">
        <h4 class="text-dark mr-2 inline-block align-middle" v-text="title"></h4>

        <vx-tooltip class="inline-block align-middle" v-if="hasToolTip" :text="toolTipTitle" style="height: 17.5px;">
          <feather-icon icon="HelpCircleIcon" svgClasses="stroke-current text-black w-5 h-5" />
        </vx-tooltip>
      </div>
    </div>
    <div class="vx-card__collapsible-content vs-con-loading__container">
      <vs-divider class="m-0"></vs-divider>
      <div class="vx-card__body p-3 text-center" v-if="hasDisplay">
        <spinner v-if="isLoading"></spinner>
        <span v-else v-text="display"></span>
      </div>

      <template v-if="$componentHelper.isset($slots, 'actionButton')">
        <slot name="actionButton"></slot>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatisticsItemCard',
  props: {
    title: {
      type: String
    },
    toolTipTitle: {
      type: String
    },
    isLoading: {
      type: Boolean,
      default: true
    },
    display: {
      type: [String, Number]
    }
  },
  computed: {
    hasToolTip () {
      return typeof this.toolTipTitle !== 'undefined' && this.toolTipTitle.length > 0 && this.toolTipTitle !== ''
    },
    hasTitle () {
      return typeof this.title !== 'undefined' && this.title.length > 0 && this.title !== ''
    },
    hasDisplay () {
      switch (typeof this.display) {
      case 'undefined':
        return false
      case 'number':
        return this.display.toString() // TODO: Check why 0 is not being displayed.
      case 'string':
        return this.display.length > 0 && this.display !== ''
      }
    }
  }
}
</script>

<style scoped>

</style>
